import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RichToolTipComponent } from 'src/app/shared/components/rich-tooltip.component';

@Component({
    selector: 'submittal-match-breakdown-report-icon',
    templateUrl: './submittal-match-breakdown-report-icon.component.html',
    styleUrls: ['./submittal-match-breakdown-report-icon.component.scss'],
    standalone: true,
    imports: [RichToolTipComponent, MatIconModule]
})
export class SubmittalMatchBreakdownReportIconComponent {
    @Input() displayText: string;
    @Input() isMatchedClass: string;
    @Input() isUnableToValidate: boolean;
}
